import { useApi } from '@/api';
import { KpiCard, Page, PageSkeleton, WalletCard } from '@/components';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';
import EventsTable from './EventsTable';

export default function ExpensesEntityPage() {
  const { address } = useParams();

  const [data, error] = useApi({
    url: `/accounting/operation/wallets/${address}/`
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page title={data.who}>
        <Flex
          flexBasis="100%"
          gap={['m', 's']}
          flexDirection={['column', 'row']}>
          <WalletCard address={address} />
          <KpiCard
            title="Total received funds"
            data={data.data}
            field="total_received_funds"
            options={{
              currency: 'USDS',
              notation: 'standard'
            }}
          />
        </Flex>

        <HistoricTabs />
        <Heading size="3">Transfers</Heading>
        <EventsTable address={address} />
      </Page>
    );
  }

  return <PageSkeleton />;
}
